<template>
  <base-section
  id="call-for-papers"
  >
    <v-container>
      <base-section-heading
      title="Call for Late Contributions"
      color="secondary"
      align="left"
      :toColor="true"
      >
Please submit a two-page paper (IEEE format). PDF electronic submissions must be done via <a href="https://easychair.org/conferences/directory?a=31223470">easychair</a>.
<br>
<strong>
- Submission Deadline: February 19th, 2024<br>
- Notification of Acceptance: March 4th, 2024<br>
- Camera Ready manuscript and author registration: March 18th, 2024<br>
</strong>
<br>
Accepted papers will be presented at LATS2024 as posters (5 minutes talk + poster) AND will be submitted for inclusion into IEEE Xplore subject to meeting IEEE Xplore’s scope and quality requirements. <br>

For further information please contact the LATS Program Co-Chairs.
</base-section-heading>
    <base-section-heading
    title="Call for Papers"
    color="secondary"
    align="left"
    :toColor="true"
    >
    Click <a
    href="LATS24_cfp.pdf"
    style="color: #b11591"
    download
    >here</a> to download our latest Call for Papers and find all the latest information in one document.
    <br />
    <br />
    <v-btn
        href="LATS24_cfp.pdf"
        rounded
        color="primary"
        dark
        download
        style="padding: 15px"
    >
        <v-icon
        left
        dark
        >
        mdi-cloud-download
        </v-icon>
        Call for Papers
        </v-btn>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'CallForPapers',

    data: () => ({
      features: [
        {
          title: 'Pixel Perfect Design',
          icon: 'mdi-fountain-pen-tip',
        },
        {
          title: 'Retina Ready',
          icon: 'mdi-cellphone',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Easily Customizable',
          icon: 'mdi-pencil-box-outline',
        },
        {
          title: 'Image Parallax',
          icon: 'mdi-image-size-select-actual',
        },
        {
          title: 'Seo Optimized',
          icon: 'mdi-ice-pop',
        },
        {
          title: '24/7 Support',
          icon: 'mdi-help-circle-outline',
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
